import { render, staticRenderFns } from "./ColumnScore.vue?vue&type=template&id=13326722&"
import script from "./ColumnScore.vue?vue&type=script&lang=ts&"
export * from "./ColumnScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports